import { createReducer, on } from '@ngrx/store';
import * as VehicleScheduleActions from '../actions/vehicle-schedule.actions';
import { ScheduleInterface } from '@fc-core/models/operator-schedule.model';

export const key = 'vehicleSchedule';

export interface State {
  vehicleSchedules: ScheduleInterface[];
  loading: boolean;
  error: any;
}

export const initialState: State = {
  vehicleSchedules: [],
  loading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(
    VehicleScheduleActions.loadVehicleSchedules,
    VehicleScheduleActions.addVehicleSchedule,
    VehicleScheduleActions.deleteVehicleSchedule,
    VehicleScheduleActions.updateVehicleSchedule,
    (state) => ({ ...state, loading: true }),
  ),
  on(VehicleScheduleActions.loadVehicleSchedulesSuccess, (state, action) => ({
    ...state,
    vehicleSchedules: action.eventList,
    loading: false,
  })),
  on(VehicleScheduleActions.addVehicleScheduleSuccess, (state, action) => ({
    ...state,
    vehicleSchedules: [...state.vehicleSchedules, action.event],
    loading: false,
  })),

  on(VehicleScheduleActions.deleteVehicleScheduleSuccess, (state, action) => ({
    ...state,
    vehicleSchedules: state.vehicleSchedules.filter(
      (vehicleSchedule) => vehicleSchedule.id !== action.event.id,
    ),
    loading: false,
  })),
  on(VehicleScheduleActions.updateVehicleScheduleSuccess, (state, action) => ({
    ...state,
    vehicleSchedules: state.vehicleSchedules.map((vehicleSchedule) =>
      vehicleSchedule.id === action.event.id ? action.event : vehicleSchedule,
    ),
    loading: false,
  })),

  on(VehicleScheduleActions.vehicleSchedulesError, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  })),
);

export const getVehicleSchedules = (state: State) => state.vehicleSchedules;
export const getLoading = (state: State) => state.loading;
export const getError = (state: State) => state.error;
